import select2 from 'select2';

import 'select2/dist/css/select2.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css'

select2($);

['turbo:load','element_inserted','turbo:frame-load'].forEach(function(e) {
 $(document).on(e, function() {
      $('.fancy-select').select2({
        theme: "bootstrap-5",
        placeholder: function() {
          $(this).data('placeholder');
        },
        allowClear: false,
        width: '100%',
        //selectionCssClass: "select2--small",
        //dropdownCssClass: "select2--small",
      }
      ); 
    });
  });

  
['turbo:load','element_inserted','turbo:morph','turbo:frame-load'].forEach(function(e) {
  document.addEventListener(e, function(){
    $(".browse-keywords").select2({
      minimumInputLength: 2,
      theme: 'bootstrap-5',
      //allowClear: false,
      width: '100%',
      placeholder: 'What you are looking for...',

      ajax: {
          url: '/searches/keywords',
          dataType: 'json',
          //type: "GET",
          quietMillis: 200,
          data: function (params) {
              return {
                  keyword: params.term
              };
          },
          processResults: function (data) {
              return {
                  results: $.map(data, function (item) {
                      return {
                          text: item.subcategory,
                          id: item.id
                      }
                  })
              };
          }
      }
    });
  });
});

  
['turbo:load','element_inserted','turbo:morph','turbo:frame-load'].forEach(function(e) {
  document.addEventListener(e, function(){
    $(".browse-cities").select2({
      minimumInputLength: 2,
      theme: 'bootstrap-5',
      allowClear: false,
      placeholder: 'City',
      width: '100%',
      //height: '100px',

      ajax: {
          url: '/searches/cities',
          dataType: 'json',
          //type: "GET",
          delay: 200,
          data: function (params) {
              return {
                  city: params.term
              };
          },
          processResults: function (data) {
              return {
                  results: $.map(data, function (item) {
                      return {
                          text: item.name,
                          id: item.id,
                          cities: item.name
                      }
                  })
              };
          }
      }
    });
  });
});